<template>
    <div id="app">
        <head-nav />
        <main class="pt-24 px-16">
            <router-view />
        </main>
    </div>
</template>

<script>
import HeadNav from '@/components/layout/HeadNav'

export default {
    components: { HeadNav },
}
</script>

<style lang="scss">
@import "css/app";
</style>
